import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';

import { Container } from '../../../components/common';
import { useReady } from '../../../shared';
import UploadTreatmentDocumentPetolo from '../components/UploadDocument/UploadTreatmentDocumentPetolo';
import SelectDocumentCreationDatePetolo from '../components/SelectDocumentCreationDate/SelectDocumentCreationDatePetolo';
import SelectTreatmentDatePetolo from '../components/SelectTreatmentDate/SelectTreatmentDatePetolo';
import TreatmentAmountPetolo from '../components/TreatmentAmount/TreatmentAmountPetolo';
import CustomerNotePetolo from '../components/CustomerNote/CustomerNotePetolo';
import SubmitClaimFormPetolo from '../components/SubmitClaimForm/SubmitClaimFormPetolo';
import {
  PARAM_CLAIM_ID,
  PETOLO_EDIT_STEP_UPLOAD_DOCUMENTS,
  PETOLO_EDIT_STEP_DOCUMENT_DATE,
  PETOLO_EDIT_STEP_TREATMENT_DATE,
  PETOLO_EDIT_STEP_TREATMENT_PRICE,
  PETOLO_EDIT_STEP_CUSTOMER_NOTE,
  PETOLO_EDIT_STEP_REVIEW,
} from './editClaimFormSteps';

const EditPetoloClaim = ({
  selectedDocuments,
  setSelectedDocuments,
  setClaimSubmitted,
  relevantClaims,
}) => {
  const ready = useReady();
  const { path } = useRouteMatch();

  const relevantClaimsCount = relevantClaims?.length || 0;

  return (
    <CSSTransition in={ready} timeout={600} classNames="slow-fade" unmountOnExit>
      <Container>
        <Route
          render={({ location }) => (
            <Switch location={location}>
              <Route
                exact
                path={path}
                render={({ match }) => {
                  const claimId = match?.params?.claimId;

                  return !Number.isNaN(Number(claimId)) ? (
                    <Redirect
                      to={{
                        pathname: PETOLO_EDIT_STEP_UPLOAD_DOCUMENTS.replace(
                          PARAM_CLAIM_ID,
                          claimId
                        ),
                        search: location.search,
                      }}
                    />
                  ) : (
                    <Redirect to="/user-claims-info" />
                  );
                }}
              />

              <Route path={PETOLO_EDIT_STEP_UPLOAD_DOCUMENTS} exact>
                <UploadTreatmentDocumentPetolo
                  selectedDocuments={selectedDocuments}
                  setSelectedDocuments={setSelectedDocuments}
                  setClaimSubmitted={setClaimSubmitted}
                  claimsCount={relevantClaimsCount}
                />
              </Route>

              <Route exact path={PETOLO_EDIT_STEP_DOCUMENT_DATE}>
                <SelectDocumentCreationDatePetolo />
              </Route>

              <Route exact path={PETOLO_EDIT_STEP_TREATMENT_DATE}>
                <SelectTreatmentDatePetolo />
              </Route>

              <Route exact path={PETOLO_EDIT_STEP_TREATMENT_PRICE}>
                <TreatmentAmountPetolo />
              </Route>

              <Route exact path={PETOLO_EDIT_STEP_CUSTOMER_NOTE}>
                <CustomerNotePetolo />
              </Route>

              <Route exact path={PETOLO_EDIT_STEP_REVIEW}>
                <SubmitClaimFormPetolo
                  selectedDocuments={selectedDocuments}
                  setSelectedDocuments={setSelectedDocuments}
                  setClaimSubmitted={setClaimSubmitted}
                />
              </Route>
            </Switch>
          )}
        />
      </Container>
    </CSSTransition>
  );
};

export default EditPetoloClaim;
